import { useCallback, useMemo, useContext } from "react";
import Context from "./context";

export const useDomainFinder = () => {
  const ctx = useContext(Context);

  if (!ctx)
    throw new Error(
      "useDomainFinder must be used within a DomainFinder provider"
    );

  const setIsOpen = ctx[1];

  const show = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const hide = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return useMemo(() => ({ show, hide }), [show, hide]);
};
